import { gql } from '@apollo/client'

export const SABRE_CREATE_MANUFACTURER = gql`
  mutation CreateManufacturer($input: CreateManufacturerInput!) {
    createManufacturer(input: $input) {
      manufacturer {
        id
        name
      }
    }
  }
`
